import { ACTION_TYPES, FETCH_STATUS } from '../Constants';

const initialState = {
  callToActionButton: {
    active: false,
  },
  error: null,
  status: FETCH_STATUS.IDLE,
  theme: 'green',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.MUNICIPALITY_DATA_CLEARED:
      return {
        ...initialState,
        status: FETCH_STATUS.IDLE,
      };
    case ACTION_TYPES.FETCH_MUNICIPALITY_STARTED:
      return {
        ...state,
        status: FETCH_STATUS.FETCHING,
      };
    case ACTION_TYPES.FETCH_MUNICIPALITY_SUCCEEDED:
      return {
        ...state,
        ...action.data,
        status: FETCH_STATUS.SUCCEEDED,
      };
    case ACTION_TYPES.FETCH_MUNICIPALITY_FAILED:
      return {
        ...state,
        error: action.error,
        status: FETCH_STATUS.FAILED,
      };
    case ACTION_TYPES.FETCH_CAREERS_FOR_MUNICIPALITY_STARTED:
      return {
        ...state,
        data: { careerStatus: FETCH_STATUS.FETCHING },
      };
    case ACTION_TYPES.FETCH_CAREERS_FOR_MUNICIPALITY_SUCCEEDED:
      return {
        ...state,
        data: { careers: action.data, careerStatus: FETCH_STATUS.SUCCEEDED },
      };
    case ACTION_TYPES.FETCH_CAREERS_FOR_MUNICIPALITY_FAILED:
      return {
        ...state,
        data: { careerStatus: FETCH_STATUS.FAILED },
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/Reducers/MunicipalityReducer.js